import { ChangeDetectionStrategy, Component, Input, inject } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { Program } from "src/app/services/api";
import { RootState } from "src/app/store";
import * as FromApp from "src/app/store/app/selectors";

export interface InfoComponentParams {
  imgSrc: string;
  title: string;
  subtext?: string;
  buttonText?: string;
}

@Component({
  selector: "app-info-modal",
  templateUrl: "info.component.html",
  styleUrls: ["info.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InfoComponent {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly modalController = inject(ModalController);

  @Input() public title: string;
  @Input() public subtext: string;
  @Input() public buttonText: string;
  @Input() public imgSrc: string;

  public readonly program$: Observable<Program> = this.store.select(FromApp.selectProgram);

  public close(): void {
    this.modalController.dismiss();
  }
}
